import { render } from "./LandingSection.vue?vue&type=template&id=1eaec50f"
import script from "./LandingSection.vue?vue&type=script&lang=js"
export * from "./LandingSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hhz/Desktop/project/patriot_games/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__